import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import { Box, IconButton, Typography } from "@mui/material"
import Visibility from "@mui/icons-material/Visibility"
import { makeStyles } from "tss-react/mui"
import { useState } from "react"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    DeviceDetailsBox,
    DeviceDetailsHeaderBox,
    DeviceDetailsInfoFullItemRow,
    DeviceDetailsInfoItem,
    DeviceDetailsSectionBoxTable,
} from "./DeviceDetailsDialogElements"
import { DeviceDetails } from "../deviceTypes"

const useStyles = makeStyles()((theme) => ({
    box: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "2rem",
        padding: "0",
        paddingLeft: "12px",
        background: "#fff",
        border: "1px solid #0000003B",
        borderRadius: "4px",
    },
    infoWrap: {
        display: "grid",
        gridTemplateColumns: "14px 1fr",
        gap: "0.625rem",
        padding: "0.75rem",
        background: theme.palette.tailwind.sky[100],
        borderRadius: "0.5rem",
        color: theme.palette.tailwind.sky[800],
        marginTop: "0.25rem",
    },
}))
type DeviceDetailsDialogSettingsSectionProps = Readonly<{
    deviceDetailsData: DeviceDetails
}>

export function DeviceDetailsDialogSettingsSection({ deviceDetailsData }: DeviceDetailsDialogSettingsSectionProps) {
    const { merchantDetails, deviceGroup, defaultLanguage, mode } = deviceDetailsData
    const { classes } = useStyles()
    const [isPINVisible, setIsPINVisible] = useState(false)

    const togglePINVisibility = () => {
        setIsPINVisible(!isPINVisible)
    }

    const displayedPINCode = isPINVisible
        ? merchantDetails?.pinCode ?? ""
        : "*".repeat(merchantDetails?.pinCode?.length ?? 0)

    return (
        <DeviceDetailsBox>
            <LocalizedStrict id="device-details-settings-info-title" attrs={{ title: true }}>
                <DeviceDetailsHeaderBox title="Settings" />
            </LocalizedStrict>
            <DeviceDetailsSectionBoxTable>
                {/* No data in the request - defaultLanguage*/}
                <LocalizedStrict id="device-details-settings-info-language" attrs={{ label: true }}>
                    <DeviceDetailsInfoItem label="Language:">
                        <span>{defaultLanguage ?? "-"}</span>
                    </DeviceDetailsInfoItem>
                </LocalizedStrict>
                <LocalizedStrict id="device-details-settings-info-pos-mode" attrs={{ label: true }}>
                    <DeviceDetailsInfoItem label="POS mode:">{mode ?? "-"}</DeviceDetailsInfoItem>
                </LocalizedStrict>
                {deviceGroup && merchantDetails?.pinCode && (
                    <LocalizedStrict id="device-details-pin-code-info-helper" attrs={{ title: true }}>
                        <DeviceDetailsInfoItem label="PIN code:">
                            <Box className={classes.box}>
                                <Typography variant="body2">{displayedPINCode}</Typography>
                                <IconButton onClick={togglePINVisibility}>
                                    {isPINVisible ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </Box>
                        </DeviceDetailsInfoItem>
                    </LocalizedStrict>
                )}
                <DeviceDetailsInfoFullItemRow>
                    <Box className={classes.infoWrap}>
                        <FontAwesomeIcon icon={faInfoCircle} />
                        <LocalizedStrict id="device-details-settings-info-pin-code-info">
                            <Typography variant="caption">
                                PIN code is used to enter protected areas in the app.
                            </Typography>
                        </LocalizedStrict>
                    </Box>
                </DeviceDetailsInfoFullItemRow>
            </DeviceDetailsSectionBoxTable>
        </DeviceDetailsBox>
    )
}
